import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ClientRoute = () => {
    const { userInfo } = useSelector(state => state.auth);
    return userInfo?.role === 'client' ? <Outlet /> : <Navigate to='/login' replace />;
};

export default ClientRoute;